import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { FaStethoscope } from "react-icons/fa";
import { BsFillTelephoneInboundFill } from "react-icons/bs";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import DashboardContext from "../../context/DashboardContext";
import { useContext } from "react";

export default function BoxOfDataNumbers(props) {
  const { customPrimaryColor } = useContext(DashboardContext);

  return (
    <CustomContainer
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          width: "220px",
          cursor: "default",
        }}
      >
        <Typography
          color="primary"
          component="p"
          sx={{ fontWeight: 600, cursor: "default" }}
          variant="h4"
        >
          {props.leftValue.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || "-"}
        </Typography>
        <Typography sx={{ fontSize: "20px" , fontWeight:600 }}>
          {props.left
            ? "VALOR TABELA"
            : "DESCONTO"}
        </Typography>
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          width: "220px",
          cursor: "default",
        }}
      >
        <Typography
          color="primary"
          component="p"
          sx={{ fontWeight: 600, cursor: "default" }}
          variant="h4"
        >
          {props.rightValue.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) || "-"}
        </Typography>
        <Typography sx={{ fontSize: "20px" , fontWeight:600 }}>
          {props.left
            ? "CLUBE CERTO"
            : "TICKET MÉDIO"}
        </Typography>
      </Box>
    </CustomContainer>
  );
}
